import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "./contexts/LanguageContext";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import CustomerLayout from "./layouts/CustomerLayout";
import AdminLayout from "./layouts/AdminLayout";
import PriceListSelectionPage from "./pages/customer/PriceListSelectionPage";
import MenuPage from "./pages/customer/MenuPage";
import CategoryPage from "./pages/customer/CategoryPage";
import PriceListMenuPage from "./pages/customer/PriceListMenuPage";
import LoginPage from "./pages/admin/LoginPage";
import DashboardPage from "./pages/admin/DashboardPage";
import CategoriesPage from "./pages/admin/CategoriesPage";
import ProductsPage from "./pages/admin/ProductsPage";
import UsersPage from "./pages/admin/UsersPage";
import PriceListsPage from "./pages/admin/PriceListsPage";

function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-10 w-10 border-2 border-[#0056A6] border-t-transparent" />
      </div>
    );
  }
  return isAuthenticated ? children : <Navigate to="/admin/login" replace />;
}

function AdminRoute({ children }) {
  const { isAdmin, loading } = useAuth();
  if (loading) return null;
  return isAdmin ? children : <Navigate to="/admin" replace />;
}

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Customer Routes */}
            <Route element={<CustomerLayout />}>
              <Route path="/" element={<PriceListSelectionPage />} />
              <Route path="/menu" element={<MenuPage />} />
              <Route path="/category/:id" element={<CategoryPage />} />
              <Route path="/price-list/:priceListId" element={<PriceListMenuPage />} />
              <Route path="/price-list/:priceListId/category/:id" element={<CategoryPage />} />
            </Route>

            {/* Admin Auth */}
            <Route path="/admin/login" element={<LoginPage />} />

            {/* Admin Routes */}
            <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
              <Route index element={<DashboardPage />} />
              <Route path="price-lists" element={<PriceListsPage />} />
              <Route path="categories" element={<CategoriesPage />} />
              <Route path="products" element={<ProductsPage />} />
              <Route path="users" element={<AdminRoute><UsersPage /></AdminRoute>} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" theme="light" richColors />
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
